import { useNumericParams } from '@domain-group/react-hooks'

import { getQueryParamsFromHash, parsePermittedQueryParams } from '@domain-group/javascript-utils'

import useCampaign from '@hooks/useCampaign'

import PageContent from './components/PageContent'

const ArtworkReviewer = () => {
  const { campaignId } = useNumericParams()

  const {
    artworkIds = '',
    publicToken,
  } = parsePermittedQueryParams(getQueryParamsFromHash(), ['artworkIds', 'publicToken'])

  // @ts-expect-error TS2345
  const parsedArtworkIds = artworkIds ? JSON.parse(artworkIds) : []

  useCampaign({ id: campaignId }, {
    performHttpRequests: !!campaignId,
    requestOptions: {
      include_agency_brand: true,
      include_agency_image: true,
      include_agency_logo: true,
      include_agent_image: true,
      include_agent_user: true,
      include_artwork_pages: true,
      include_artwork_preview: true,
      include_artwork_page_preview: true,
      include_artwork_public_download_link: true,
      include_attachment_file: true,
      include_brand_public_link_cover_image: true,
      include_brand_public_link_logo: true,
      include_campaign_agency: true,
      include_campaign_agents: true,
      include_campaign_category: true,
      include_campaign_images: true,
      include_campaign_orders: true,
      include_campaign_sale_method: true,
      include_campaign_team: true,
      include_order_item_artwork: true,
      include_order_item_service: true,
      include_order_items: true,
      exclude_sensitive_data: !!publicToken,
      public_token: publicToken,
    },
  })

  return (
    <PageContent artworkIds={parsedArtworkIds} campaignId={campaignId} />
  )
}

export default ArtworkReviewer
